import { render, staticRenderFns } from "./ConversationModuleHeader.vue?vue&type=template&id=3d17ca66&scoped=true&"
import script from "./ConversationModuleHeader.vue?vue&type=script&lang=js&"
export * from "./ConversationModuleHeader.vue?vue&type=script&lang=js&"
import style0 from "./ConversationModuleHeader.vue?vue&type=style&index=0&id=3d17ca66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d17ca66",
  null
  
)

export default component.exports